import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Container,
  Grid,
  Typography,
  Box,
  TextField,
  makeStyles,
  Divider,
  useMediaQuery,
} from '@material-ui/core';
import MortgageCalculator from "./MortgageCalculator"
import InputAdornment from '@material-ui/core/InputAdornment';
import CalInfo from './CalInfo';



const labels = ['Principal & Interest', 'Property tax', "Homeowners's insurance", 'PMI', 'HOA fees'];
const initialData = [0, 300, 100, 160, 100]; // Initial data for the doughnut chart

const chartData = {


  labels: labels,
  datasets: [
    {
      label: '# of Votes',
      data: initialData,
      backgroundColor: [
        'rgb(30, 144, 255)',
        'rgb(65, 105, 225)',
        'rgb(100, 149, 237)',
        'rgb(176, 196, 222)',
        'rgb(0, 0, 205)',

      ],
      borderWidth: 1,
    },
  ],

};

const options = {
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
    },
    datalabels: {
      display: true,
    },
  },
};





const useStyles = makeStyles(() => ({

  bannerContainer: {
    marginTop: '100px',

  },



  textBox: {
    '& .MuiInputBase-root': {
      borderRadius: '4px',
      border: '1px solid #000',
      backgroundColor: '#FFFFFF',
      paddingRight: '4px',
      textAlign: 'right',
      width: '100%', //  TextField Width
      height: '70px',
      fontSize: '28px', // Text font size
    },
    '& .adornment': { // Remove the extra backtick (`) here
      fontSize: 24,
    },
    '& .MuiInputBase-input': {
      padding: '6px 4px',
      textAlign: 'right',
    },

  },
  label: {
    fontSize: '28px',
    width: '100%',
    textAlign: 'left',
    marginRight: '8px', // space between label and TextField
    marginTop: '15px'

  },
  labelText: {
    fontFamily: 'Inter',
    fontSize: '28px',
    fontWeight: '500',
    width: '100%',
    textAlign: 'left',
    marginRight: '8px', // space between label and TextField
  },
  labelStart: {
    fontFamily: 'Inter',
    fontSize: '28px',
    fontFamily: 'Inter',
    width: '100%',
    textAlign: 'right',
    marginRight: '8px', // space between label and TextField
  },
  labelFinal: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: '28px',
    textAlign: 'right',
    marginRight: '8px', // space between label and TextField
  },

  divider: {
    margin: '8px 0', //  divider margin
    backgroundColor: 'black',
  },
  totalPaymentContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #000',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  textRight: {
    textAlign: 'right',
    fontSize: '28px',
    width: '25%', //  TextField Width
  },



}));

const ColorPalette = ({ handleChange, monthlyPayment }) => {

  const classes = useStyles();
  const [inputValues, setInputValues] = useState(initialData);

  useEffect(() => {
    const newData = [...inputValues];
    newData[0] = monthlyPayment;
    setInputValues(newData);
    handleChange(newData);
  }, [monthlyPayment]);

  const handleInputChange = (event, index) => {
    const newData = [...inputValues];
    newData[index] = parseInt(event.target.value, 10) || 0;
    setInputValues(newData);
    handleChange(newData);
  };

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const isMobile = window.innerWidth <= 600; // Set your desired mobile breakpoint here


  return (
    <Container >
      <Box marginTop={8} marginLeft={2}>
        {labels.map((label, index) => (
          <React.Fragment key={index}>
            {/*//  Box Label,TextBox*/}
            <Box
              display="flex"
              flexDirection={isMobile ? 'column' : 'row'}
              alignItems={isMobile ? 'center' : 'flex-start'}
              marginBottom={3}
              marginTop={3}
            >
              {/*// Bullet */}
              <Box className="bullet" marginTop={3}
                width={50}
                height={25}
                marginRight={!isMobile ? 3 : 0}
                borderRadius="50%"
                bgcolor={chartData.datasets[0].backgroundColor[index]}
              />

              {/*// Label */}

              <Typography variant="body2" className={classes.label} sx={{ fontSize: '28px' }}>
                {label}
              </Typography>



              {index !== 0 && !isMobile && (
                <>
                  <span style={{ marginLeft: '8px', marginTop: '15px', fontSize: '32px', color: 'black' }}>
                    +&nbsp;
                  </span>
                </>
              )}



              {index === 0 ? (
                <Box display="flex" alignItems="center" marginTop={2}>

                  <Typography className={classes.labelStart} >
                    ${formatNumberWithCommas(inputValues[index])}
                  </Typography>
                </Box>


              ) : (
                <TextField
                  type="number"
                  value={inputValues[index]}
                  onChange={(event) => handleInputChange(event, index)}
                  variant="outlined"
                  className={classes.textBox}
                  inputProps={{
                    style: { textAlign: isMobile ? 'right' : 'right' },
                    step: 1,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start" className={classes.adornment}>
                        <Typography variant="h5">$</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              )
              }
            </Box>
            {index < labels.length - 1 && <Divider className={classes.divider} />} {/* Horizontal divider */}
          </React.Fragment>
        ))}
      </Box>
    </Container>
  );
};



const Cal4 = () => {
  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const plugins = [{
    beforeDraw: function (chart) {
      var width = chart.width,
        height = chart.height,
        ctx = chart.ctx;
      ctx.restore();
      var fontSize = (height / 160).toFixed(2);
      ctx.font = fontSize + "em sans-serif";
      ctx.textBaseline = "top";
      var text = "Foo-bar",
        textX = Math.round((width - ctx.measureText(text).width) / 2),
        textY = height / 2;
      ctx.fillText(text, textX, textY);
      ctx.save();
    }
  }]

  const isMobile = useMediaQuery('(max-width: 600px)');

  const [chartValues, setChartValues] = useState(initialData);
  const [monthlyPayment, setMonthlyPayment] = useState(0);

  const handleMonthlyPaymentChange = (value) => {
    setMonthlyPayment(value);
  };

  const handleChartChange = (newData) => {
    setChartValues(newData);
  };

  const updatedChartData = {
    ...chartData,
    datasets: [
      {
        ...chartData.datasets[0],
        data: chartValues,
      },
    ],


  }




  const classes = useStyles();

  const calculateTotalMonthlyPayment = () => {
    const sum = chartValues.reduce((a, b) => a + parseFloat(b), 0);
    return (sum).toFixed(2);
  };

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }



  const centerTitlePlugin = {
    id: 'center-title-plugin',
    beforeRender: function (chart) {
      const { width, height, ctx } = chart;
      const centerText = 'Total';
      const fontSize = 20;
      const textX = width / 2;
      const textY = height / 2;

      ctx.restore();
      ctx.font = `${fontSize}px Arial`;
      ctx.fillStyle = '#000';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(centerText, textX, textY);
      ctx.save();
    },
  };

  if (!options.plugins) {
    options.plugins = {}; // Create plugins object if it doesn't exist
  }

  if (!options.plugins.plugins) {
    options.plugins.plugins = []; // Create plugins array if it doesn't exist
  }

  options.plugins.plugins.push(centerTitlePlugin);

  return (

    <Container maxWidth="xl" className="calContainer">

      <Grid container spacing={2}>

        {/*Render Mortgage Calculator */}
        <Box marginBottom={8}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            {/* Mortgage Cal */}
            <MortgageCalculator onMonthlyPaymentChange={handleMonthlyPaymentChange} />
          </Grid >
        </Box>

        <Grid container spacing={2}>

          <Grid item xs={12} md={6}>
            {/* Center of Chart*/}
            <Box height="auto" className={classes.chartContainer}>
              <div className="donutChartContainer">
                <div className="chartCenter">
                  <Typography variant="h6" className="chartCenterText" style={{ fontFamily: 'Inter', fontWeight: 500, }}>
                    Total Monthly Payment
                  </Typography>
                  <Typography variant="h6" className="chartCenterText" style={{ fontFamily: 'Inter', fontWeight: 700, fontSize: 40, marginTop: 5 }}>
                    <span style={{ verticalAlign: 'super', fontSize: '20px', fontWeight: 500, marginRight: '10px' }}>$</span>{formatNumberWithCommas(calculateTotalMonthlyPayment())}
                  </Typography>
                </div>
                {/* Chart*/}
                <div className="chartWrapper">
                  <Doughnut data={updatedChartData} options={options} />
                </div>
              </div>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <ColorPalette handleChange={handleChartChange} monthlyPayment={monthlyPayment} />
            <Container>
              <Grid item xs={12} md={12}>
                {/*Total Monthly Payment */}
                <Box display="flex" justifyContent="space-between" marginLeft={2} paddingTop={3}>
                  <Typography variant="h1" className={classes.labelText} >
                    Total Monthly Payment
                  </Typography>


                  <span style={{ fontSize: '32px', color: 'black' }}>=&nbsp;</span>

                  <Typography variant="h1" className={classes.labelFinal} >
                    ${formatNumberWithCommas(calculateTotalMonthlyPayment())}
                  </Typography>



                </Box>

              </Grid>
            </Container>
          </Grid>

        </Grid>


        <CalInfo />



      </Grid >

    </Container>
  );
};

export default Cal4;
